module.exports = __webpack_public_path__ + "static/media/oven.af19d74e.png";